import { Helmet } from 'react-helmet-async';
import UserManagementView from './components/Asset_type_Management_View';
import {
  PageTitleWrapper,
  PageHeader,
  showErrorMessage,
} from '../../shared/components/index';
import {
  Grid,
  Container,
  Button,
  TextField,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { useEffect, useState, MouseEvent } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAssetTypeData } from './services/asset-type_Management.service';
import * as assetTypeEvent from './services/asset-type_Management.service';
import { selectUserState } from 'src/auth/login/services/userSlice';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useTranslation } from 'react-i18next';
import {
  I18N,
  LIST_VIEW,
} from '../../shared/constants/constants';
import * as ROUTES from '../../shared/constants/routes';
import GridViewSharpIcon from '@mui/icons-material/GridViewSharp';
import TableRowsTwoToneIcon from '@mui/icons-material/TableRowsTwoTone';
import { VIEW_TYPE } from './utils/utils';
import { useLocation, useSearchParams } from 'react-router-dom';
import AddUserModal from './components/Asset-type_Modal';

const AssetManagement = () => {
  const [selectedTab, setSelectedTab] = useState<string | null>(
    LIST_VIEW.TABLE_VIEW
  );
  const [open, setOpen] = useState<boolean>(false);
  const [viewType, setViewType] = useState<string>(VIEW_TYPE.USER_MANAGEMENT);
  const [isAddModal, setIsAddModal] = useState<boolean>(true);
 // const { t } = useTranslation(I18N.ASSET_TYPE_MANAGEMENT);
  const { t } = useTranslation(I18N.DEFAULT);
  const dispatch = useDispatch<any>();
  const [userList, setUserList] = useState([]);
  const {
    assetTypeData,
    isOrgUserListUpdated,
    isError,
    errorMessage,
    userAssetsData,
    isUserAssetsListUpdated
  } = useSelector(assetTypeEvent.selectorAssetTypeState);
  const { selectedOrganization, loginUserRole } = useSelector(selectUserState);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [breadcrumbsHeading, setBreadcrumbsHeading] = useState(t('booking-d-lite'));
  const [headerSubtitle, setHeaderSubtitle] = useState(t('booking-d-lite'));
  const [userAssetsList, setUserAssetsList] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  const location = useLocation();
  const [params] = useSearchParams();

  function setInitialHeaderDetail(
    viewType,
    breadcrumbsHeading,
    subtitle,
    breadcrumbs
  ) {
    setViewType(viewType);
    setBreadcrumbsHeading(breadcrumbsHeading);
    setBreadcrumbs(breadcrumbs);
    setHeaderSubtitle(subtitle);
  }

  useEffect(() => {
    setInitialHeaderDetail(
      VIEW_TYPE.USER_MANAGEMENT,
      t('asset-type.asset-type_management'),
      `${t('asset-type.list-all-asset-type-label')} ${selectedOrganization.tenantName}`,
      getBreadcrumbs(VIEW_TYPE.USER_MANAGEMENT)
    );
  }, [location]);

  const getBreadcrumbs = (viewType) => {
    const breadcrumbs = [
      {
        name: t('organization'),
        route: `${ROUTES.ADMIN_LOGIN}${ROUTES.ORGANIZATION}`
      },
      {
        name: selectedOrganization.tenantName,
        route: ROUTES.USER_MANAGEMENT
      }
    ];
    return viewType == VIEW_TYPE.USER_MANAGEMENT
      ? breadcrumbs
      : [
        ...breadcrumbs,
        {
          name: params.get('user')
        }
      ];
  };

  useEffect(() => {
    if (isError) {
      dispatch(assetTypeEvent.setIsError(false));
      if (errorMessage !== '') {
        return showErrorMessage(errorMessage, {
          theme: 'colored',
          position: 'top-right',
          autoClose: 5000
        });
      }
    }
  }, [isError]);

  useEffect(() => {
    dispatch(getAssetTypeData(selectedOrganization.id));
    const breadcrumbsList = [
      {
        name: `organization`,
        route: `${ROUTES.ADMIN_LOGIN}${ROUTES.ORGANIZATION}`
      },
      {
        name: `${selectedOrganization.tenantName}`
      }
    ];
    setBreadcrumbs(breadcrumbsList);
  }, []);

  useEffect(() => {
    setUserList(assetTypeData);
  }, [assetTypeData]);

  useEffect(() => {
    setOpen(false);
    closeDialog();
    if (isOrgUserListUpdated) {
      dispatch(assetTypeEvent.getAssetTypeData(selectedOrganization.id));
      dispatch(assetTypeEvent.setIsAdminListUpdated(false));
    }
  }, [isOrgUserListUpdated]);

  useEffect(() => {
    setUserAssetsList(userAssetsData);
  }, [userAssetsData]);

  useEffect(() => {
    setOpen(false);
    closeDialog();
    if (isOrgUserListUpdated) {
      dispatch(assetTypeEvent.getAssetTypeData(selectedOrganization.id));
      dispatch(assetTypeEvent.setIsAdminListUpdated(false));
    }
  }, [isOrgUserListUpdated]);

  const handleAddUserButtonClick = () => {
    setIsAddModal(true);
    setOpen(true);
  };

  const handleFilterUsers = (value: string) => {
    const filterUsersData = assetTypeData.filter(function (item) {
      return item.name.toLowerCase().includes(value.toLowerCase());
    });
    setUserList(filterUsersData);
  };

  const handleDeleteIconClick = (row: any) => {
    setOpen(false);
    const payload = {
      id: row.id,
      tenantId: selectedOrganization.id,
    };
    dispatch(assetTypeEvent.deleteAssetType(payload));
  };

  const handleClose = (value) => {
    setOpen(false);
  };
  const closeDialog = () => {
    setOpen(false);
  };

  const onCancel = () => {
    closeDialog();
  };

  const handleEditIconClick = (row) => {
    setSelectedUser(row);
    setIsAddModal(false);
    setOpen(true);
  };

  const handleSwitchIconClick = (row) => {
  };

  const onSubmit = (values: any) => {
    setOpen(false);
    if (!isAddModal) {
      dispatch(
        assetTypeEvent.updateAssetType({
          id: values.id,
          status: values.status,
          name: values.name,
          tenantId: selectedOrganization.id
        })
      );
    } else {
      dispatch(
        assetTypeEvent.addAssetType({
          status: values.status,
          name: values.name,
          role: values.role,
          tenantId: selectedOrganization.id
        })
      );
    }
  };

  const handleViewOrientation = (
    _event: MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue !== null) {
      setSelectedTab(newValue);
    }
  };

  return (
    <>
      <Helmet>
        <title>BookingDLite Asset Management</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader
          breadcrumbs={breadcrumbs}
          heading={breadcrumbsHeading}
          subHeading={headerSubtitle}
        >
          {viewType == VIEW_TYPE.USER_MANAGEMENT && (
            <Button
              size={'small'}
              sx={{ pt: 1, pb: 1 }}
              className="letter-spacing"
              variant={'contained'}
              startIcon={<AddTwoToneIcon fontSize="small" />}
              onClick={handleAddUserButtonClick}
            >
              {t('asset-type.add-asset-type')}
            </Button>
          )}
          <TextField
            size={'small'}
            id="outlined-search"
            label={t('asset-type.search-asset-type')}
            type="search"
            onChange={(e) => handleFilterUsers(e.target.value)}
          />
          <ToggleButtonGroup
            value={selectedTab}
            exclusive
            onChange={handleViewOrientation}
            size={'small'}
          >
            <ToggleButton disableRipple value={LIST_VIEW.CARD_VIEW}>
              <GridViewSharpIcon />
            </ToggleButton>
            <ToggleButton disableRipple value={LIST_VIEW.TABLE_VIEW}>
              <TableRowsTwoToneIcon />
            </ToggleButton>
          </ToggleButtonGroup>
        </PageHeader>
      </PageTitleWrapper>

      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <UserManagementView
              handleDeleteIconClick={handleDeleteIconClick}
              handleSwitchIconClick={handleSwitchIconClick}
              handleEditIconClick={handleEditIconClick}
              inputUserData={userList}
              inputLoginUserRole={loginUserRole}
              inputSelectedTab={selectedTab}
              viewType={viewType}
              userAssetsList={userAssetsList}
            />
          </Grid>
        </Grid>
        <AddUserModal
          isAddModal={isAddModal}
          open={open}
          onClose={handleClose}
          onSubmit={onSubmit}
          handleClose={handleClose}
          editObject={selectedUser}
        ></AddUserModal>
      </Container>
    </>
  );
};

export default AssetManagement;
